let newServer = VE_ENV.SERVER
let pyServer = VE_ENV.PYSERVER
let newPathServer = VE_ENV.NEW_SERVER
let oldServer = "https://birdseye-api.sysuimars.com/"
let fosterServer = "https://foster-api.sysuimars.com/"

module.exports = {
    base_url :oldServer + "site/",
    base_dev_site_url :newServer + "site/",
    base_foster_url: fosterServer + 'app/',
    base_mini_url :oldServer + "mini/",
    base_dev_url :newServer + "mini/",
    base_new_url :newPathServer + "api/",
    base_py_url :pyServer,
    image_url:oldServer+"images/",
    mini_key:"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9",
    base_img_url : "https://img.sysuimars.com/",
    base_img_url2 : "https://birdseye-img-ali-cdn.sysuimars.com/",
    base_img_url3: "https://birdseye-img.sysuimars.com/",
    base_img_url4: "https://xyz2.sysuimars.cn/",
    base_video_url : "https://minio.sysuimars.com/sysuimars/",
    resize: "?x-oss-process=image/resize,w_1000",
    resize_300: "?x-oss-process=image/resize,w_300,p_30/format,webp/quality,q_20",
    //获取请求头中的参数体
    getOptBody : (opt)=>{
        return JSON.parse(opt.body);
    },
    //需要忽略成功提示的请求
    igSuccessUrl:[
        "get",
        "page",
        "index",
        "sign",
        "List",
        "info",
        "Info",
        "Data",
        "list",
        "air_route",
        "find",
        "insert",
        "Insert",
        "image",
        "Image",
        "plugin_weather_report",
        "plugin_weather_warning_record",
        "poi",
        "mini_credential",
        "garden",
        "updateStatus",
        "mini_pop_control",
        "mini_session_store",
        "check",
    ]
}





